export default "__VITE_ASSET__Dm9pk1Ou__"